<template>
    <f7-page
        name="Profile"
        no-swipeback
        no-navbar
        class="profile-scroll onboardingBg withHalfBg"
    >
        <div style="position: relative">
            <f7-link
                v-if="isMe"
                icon-only
                style="position: absolute; top: 10px; padding: 0 16px; right: 0px; font-size: 30px; color: #999999"
                icon="ion-ios-gear"
                href="/settings"
            />
        </div>
        <div class="profileMainBg">

            <!-- <f7-navbar
            :sliding="false"
            large
            title-large="My Profile"
            no-sliding
        >
            <f7-nav-title>My Profile</f7-nav-title>
            <f7-nav-right>
                <f7-link
                    v-if="isMe"
                    icon="ion-ios-gear-outline"
                    href="/settings"
                />
            </f7-nav-right>
        </f7-navbar> -->
            <template v-if="(trackerData.timeForTracker || typeof trackerData.lastOne.choiceInt !== 'undefined')">

                <f7-block class="center trackerBg">
                    <img
                        v-if="!trackerData.lastOne"
                        class="pulseImg"
                        src="../img/0.4/pulse/Pulse_2.png"
                    >
                    <img
                        v-else-if="trackerData.lastOne.choiceInt === 0"
                        class="pulseImg"
                        src="../img/0.4/pulse/Great.png"
                    >
                    <img
                        v-else-if="trackerData.lastOne.choiceInt === 1"
                        class="pulseImg"
                        src="../img/0.4/pulse/Good.png"
                    >
                    <img
                        v-else-if="trackerData.lastOne.choiceInt === 2"
                        class="pulseImg"
                        src="../img/0.4/pulse/Neutral.png"
                    >
                    <img
                        v-else-if="trackerData.lastOne.choiceInt === 3"
                        class="pulseImg"
                        src="../img/0.4/pulse/Bad.png"
                    >
                    <img
                        v-else-if="trackerData.lastOne.choiceInt === 4"
                        class="pulseImg"
                        src="../img/0.4/pulse/Nothing.png"
                    >
                    <img
                        v-else-if="trackerData.lastOne.choiceInt === 7"
                        class="pulseImg"
                        src="../img/0.4/pulse/Pulse_2.png"
                    >
                    <div
                        v-else
                        class="pulseImg"
                    />
                    <h1 style="margin: 24px 0 2px 0;">My Pulse</h1>

                    <div
                        v-if="trackerData.timeForTracker"
                        style="margin: 0 auto; max-width: 180px; position: relative"
                    >
                        <f7-button
                            color="red"
                            fill
                            round
                            small
                            href="#"
                            @click="goToInPopup(`/units/285`)"
                        >Take your pulse</f7-button>
                        <span
                            class="badge color-red"
                            style="padding-top: 3px; border: 1px solid #FC6F65; background: white; color: #FC6F65; position: absolute; top: -6px; right: -6px"
                        >1</span>
                    </div>
                    <p
                        v-else
                        style="margin-top: 10px; font-size: 16px;color: #f07969;font-weight: bold;line-height: 12px; color: #aaa !important;"
                    >Next pulse {{ timeTill() || ' in 7 days' }}</p>
                    <br>
                </f7-block>
                <p
                    class="moreLinks"
                    style="margin-top: -76px; padding-bottom: 66px; margin-right: 0px"
                >
                    <a
                        href="/tracker"
                        class="moreLink"
                        style="padding: 3px 0px 3px 10px"
                    >View &mdash;</a>
                </p>
            </template>
        </div>
        <div class="profileContentSectionWave" />
        <div class="profileContentSectionWave2">
            <f7-block style="margin-bottom: 0px; margin-top: 0px;">
                <f7-toolbar
                    tabbar
                    labels
                    class="exploreTabbar"
                >
                    <a
                        href="/profile/"
                        class="tab-link tab-link-active"
                        data-route-tab-id="ptab-1"
                    ><span class="">Bookmarks<br>•</span></a>
                    <a
                        href="/profile/completed"
                        class="tab-link"
                        data-route-tab-id="ptab-2"
                    ><span class="">Completed<br>•</span></a>
                    <a
                        href="/profile/activity"
                        class="tab-link"
                        data-route-tab-id="ptab-3"
                    ><span class="">Activity <span
                                v-if="unreadEvents"
                                class="badge color-red"
                                style="color: white; padding-top: 4px; margin-left: 3px; margin-top: -3px;"
                            >{{ unreadEvents }}</span><br>
                            •
                        </span></a>
                </f7-toolbar>
            </f7-block>
            <div class="profileContentSection">
                <f7-tabs routable>
                    <f7-tab
                        id="ptab-1"
                        tab-active
                    />
                    <f7-tab id="ptab-2" />
                    <f7-tab id="ptab-3" />
                </f7-tabs>
                <br><br>
            </div>
        </div>
        <app-tabbar tab="profile" />
    </f7-page>
</template>

<script>
import moment from 'moment';

import AppTabbar from '../components/appTabbar.vue';

export default {
    store: [
        'api',
        'user',
        'topics',
        'topicsIndex',
        'courses',
        'coursesIndex',
        'myEvents',
        'unreadEvents',
        'trackerData',
        'timeOfLast'
    ],
    components: {
        // Custom,
        AppTabbar
    },
    data () {
        return {
            isLoaded: false,
            moreBookmarks: false,
            currentUser: {
                id: 0,
                username: ''
            },
            userId: 0,
            isMe: true
        };
    },
    computed: {},
    created: function () {
        this.isLoaded = false;
        if (!this.$f7route.params.id) {
            this.userId = this.user.id;
            this.isMe = true;
        } else {
            this.userId = this.$f7route.params.id;
        }
        this.getUser();
        if (this.myEvents.length) {
            this.myShortEvents = this.myEvents.splice(0, 2);
            this.hasMoreEvents = !!(this.myEvents.length > 2);
        }
        this.$events.fire('pulse-get', () => {
            this.loaded = true;
        });
    },
    mounted: function () {
        if (this.trackerData) {
            this.isLoaded = true;
            if (this.trackerData.lastOne) {
                this.timeOfLast = this.trackerData.lastOne.createdAt;
            }
        }
    },
    methods: {
        timeTill: function () {
            return this.timeOfLast
                ? moment(this.timeOfLast)
                    .add(7, 'd')
                    .fromNow()
                : ' ';
        },
        goToInPopup: function (url) {
            f7.views['popup'].router.navigate(url, {
                animate: false,
                clearPreviousHistory: true
            });
            if (!pgap) window.history.pushState(null, "", '/web' + url);
            setTimeout(() => {
                f7.popup.get('#popup').open();
            }, 150);
            //f7.statusbar.setTextColor('white');
        },
        findPagePosition: function (bookmark) {
            for (let i = 0; i < bookmark.unit.slides.length; i++) {
                const slide = bookmark.unit.slides[i];
                if (bookmark.slideId === slide.id) {
                    return i + 1;
                }
            }
        },
        getUser: function () {

            this.$http.get(`${this.api}/users/${this.userId}`).then(
                response => {
                    this.user = response.body;
                },
                () => {
                    console.error('Could not update user');
                }
            );

        }
    }
};
</script>
<style lang="less" scoped>
@import '../css/colors.less';
.trackerBg {
    margin: 110px 0 20px 0;
}
.pulseImg {
    width: 180px;
    height: 180px;
}
.weather {
    line-height: 40px;
    font-size: 100px;
    color: white;
    z-index: 100;
    position: relative;
}
.likeNavbar {
    margin: 0px;
    padding: 4px 16px 0;
    padding-top: calc(env(safe-area-inset-top) + 22px);
    height: 44px;
    width: 100%;
    a {
        float: right;
        font-size: 38px;
        color: white;
    }
    position: fixed;
    z-index: 10;
}
.moreLinks {
    padding: 0;
    text-align: right;
    margin: -20px 16px 0;
    text-transform: uppercase;
    font-family: AndesMedium;
    letter-spacing: 1px;
    font-weight: bold;
    font-size: 12px;
    color: #ff6f61;
    letter-spacing: 0.8px;
}
.moreLink {
    font-size: 15px;
    color: @coral;
    font-family: AndesMedium;
    text-transform: uppercase;
    line-height: 44px;
    float: right;
    z-index: 100;
    position: relative;
}
.profileMainBg {
    background-color: white;
}
.profileContentSection {
    width: 100%;

    max-width: 100vw;
    margin-top: -20px;
}
.profileContentSectionWave {
    padding-top: 20px;
    width: 100%;
    min-height: 60px;
    max-width: 100vw;
    overflow-x: hidden;
    background-color: @darkBackground;
    background-image: url('../img/0.4/bgwave.png');
    // background-size: 307px 11px;
    background-size: 460.5px 16.5px;
    background-position: top left;
    background-repeat: repeat-x;
}
.profileContentSectionWave2 {
    min-height: 60vh;
    background-color: @darkBackground;
}
.theme-dark {
    .profileMainBg {
        background-color: #000;
    }
    .profileContentSectionWave {
        background-color: #1c1c1d;
        background-image: url('../img/0.4/bgwavedark.png');
    }
    .profileContentSectionWave2 {
        background-color: #1c1c1d;
    }
    .profileContentSection {
        background-color: #1c1c1d;
    }
}
</style>
